var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14L21 15.4L18.9 16.8L21 18.9L18.9 21L16.8 18.9L15.4 21L14 14Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4697 13.4697C13.647 13.2924 13.9012 13.2154 14.1471 13.2646L21.1471 14.6646C21.4446 14.7241 21.6769 14.9569 21.7358 15.2545C21.7946 15.552 21.6684 15.8558 21.416 16.024L20.0772 16.9166L21.5303 18.3697C21.8232 18.6626 21.8232 19.1374 21.5303 19.4303L19.4303 21.5303C19.1374 21.8232 18.6626 21.8232 18.3697 21.5303L16.9166 20.0772L16.024 21.416C15.8558 21.6684 15.552 21.7946 15.2545 21.7358C14.9569 21.6769 14.7241 21.4446 14.6646 21.1471L13.2646 14.1471C13.2154 13.9012 13.2924 13.647 13.4697 13.4697ZM14.9561 14.9561L15.7803 19.0774L16.176 18.484C16.3006 18.297 16.5025 18.1758 16.7261 18.1537C16.9497 18.1315 17.1715 18.2108 17.3303 18.3697L18.9 19.9394L19.9394 18.9L18.3697 17.3303C18.2108 17.1715 18.1315 16.9497 18.1537 16.7261C18.1758 16.5025 18.297 16.3006 18.484 16.176L19.0774 15.7803L14.9561 14.9561Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4C2.25 3.0335 3.0335 2.25 4 2.25H20C20.9665 2.25 21.75 3.03351 21.75 4V11C21.75 11.4142 21.4142 11.75 21 11.75C20.5858 11.75 20.25 11.4142 20.25 11V4C20.25 3.86192 20.1381 3.75 20 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V20C3.75 20.1381 3.86192 20.25 4 20.25H10.5C10.9142 20.25 11.25 20.5858 11.25 21C11.25 21.4142 10.9142 21.75 10.5 21.75H4C3.03351 21.75 2.25 20.9665 2.25 20V4Z",
    fill: "#1C1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/Detail.427057dd.svg";
export { ForwardRef as ReactComponent };